import {db, firebaseAuth} from "./constants"
import {store} from "../redux/state";
import {apiConstants, AUTH_ERROR} from "../redux/actions/constants";
const protobuf = require("protobufjs");
const base_endpoint = "https://crispy-api-dot-pogon-155405.appspot.com/v1"

export interface User {
  pk: number;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
}

export interface CompanyData {
  id: number;
  name: string;
  user_managers: User[];
  user_owners: User[];
  geo_companies: GeoCompany[];
}

export interface GeoCompany {
  id: number;
  country_code: string;
  company_id: number;
}

export class HITCardBlueprintAction {
  text: string;
  color: string;
  constructor(text, color) {
    this.text = text;
    this.color = color;
  }
}

export class HITCardBlueprintRowData {
  title: string;
  columns: [HITCardBlueprintColumnData];
  constructor(title, columns) {
    this.title = title;
    this.columns = columns;
  }
}

export class HITCardBlueprintColumnData {
  name: string;
  nameColor: string;
  value: string;
  valueColor: string;
  deltaArrowDirection: bool;
  constructor(name, nameColor, value, valueColor, deltaArrowDirection) {
    this.name = name;
    this.nameColor = nameColor;
    this.value = value
    this.valueColor = valueColor
    this.deltaArrowDirection = deltaArrowDirection
  }
}

export function getData(success, failure) {
  protobuf.load("card.proto", function(err, root) {
    if (err) {
      failure && failure()
    }
    var HitCard = root.lookupType("HITCards.Card")

    db.collection("cards").onSnapshot((querySnapshot) => {
      var cards = []
      let docs = querySnapshot.docs;
      if (docs.length == 0) {
        success && success(null)
      } else {
        success && success(docs.map((doc) => {
          let payload = doc.data()
          return HitCard.toObject(payload);
        }));
      }
    });
  });

}

export function makeApiCall(url, method = "get", token = true, body = null, contentType = "application/json") {
  const fetchRequest = () => {
    const authorization = token
      ? `Token ${localStorage.getItem("user_key")}`
      : null;
    const headers = {
      Accept: "application/json",
      Authorization: authorization
    };
    if (contentType !== null) {
      headers["Content-Type"] = contentType;
    }
    return fetch(url, {method, headers, body}).then(function(response) {
      if (response.status >= 400 && response.status < 600) {
        if (response.status === 401) {
          return store.dispatch({type: AUTH_ERROR});
        }
        return response.json().then((data) => {
          throw new Error(JSON.stringify(data));
        });

      } else {
        return response.json().then((data) => {
          return data;
        }, (error) => {
          return error;
        });
      }
    }).catch((e) => Promise.reject(e));
  };

  return fetchRequest();
}

export function addCardToDB(proto, callback) {
  let Card_JSON = proto.toJSON()
  Card_JSON.state = 0
  db.collection("cards").add(Card_JSON).then(function(docRef) {
    callback && callback(true)
  }).catch(function(error) {
    callback && callback(false)
  });
}

export function login(email, password) {
  const body = JSON.stringify({email: email, password: password});
  return makeApiCall(base_endpoint + "/auth/login/", "post", false, body);
}

export function logout() {
  return makeApiCall(base_endpoint + "/auth/logout/", "post", true);
}

export function getCompanies() {
  return makeApiCall(base_endpoint + "/companies/", "get", true);
}

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}



// WEBPACK FOOTER //
// ./src/utils/api.js